import { ShieldCheck, Crosshair, Palette, Globe2 } from "lucide-react";
import { useLang } from "../../i18n";
import { Reveal } from "./Section";

const ICONS = [ShieldCheck, Crosshair, Palette, Globe2];

const Features = () => {
  const { t } = useLang();
  return (
    <section className="grid grid-cols-2 lg:grid-cols-4 gap-px bg-[#232733] border-b border-[#232733]" data-testid="features-strip">
      {t.features.map((f, i) => {
        const Icon = ICONS[i];
        return (
          <Reveal key={i} delay={i * 0.08} className="bg-[#0A0B0E]">
            <div className="px-6 lg:px-10 py-10 group hover:bg-[#111318] transition-colors h-full">
              <Icon size={22} className="text-[#0055FF] group-hover:text-[#FF4D00] transition-colors" strokeWidth={1.5} />
              <div className="font-display text-lg font-medium text-white mt-5 tracking-tight">{f.title}</div>
              <div className="font-mono text-[10px] uppercase tracking-[0.2em] text-[#647087] mt-2">{f.sub}</div>
            </div>
          </Reveal>
        );
      })}
    </section>
  );
};

export default Features;
